import { z } from 'zod'
import { EmissionReportWithProductionRoute } from './EmissionReportModel'

const stockChangeType = z.enum(['IN', 'OUT', 'ALLOCATED'])

export const preconsumerScrapMaterialSchema = z.object({
  id: z.string(),
  stockChangeType: stockChangeType,
  internalId: z.string().nullable(),
  date: z.string(),
  quantityInTonnes: z.number(),
  proofFilePath: z.string().nullable(),
  details: z.string().nullable(),
  supplierId: z.string(),
  createdAt: z.string(),
  emissionReportId: z.string().optional()
})

export const preconsumerScrapMaterialCreateSchema = preconsumerScrapMaterialSchema.pick({
  stockChangeType: true,
  internalId: true,
  date: true,
  quantityInTonnes: true,
  proofFilePath: true,
  details: true,
  emissionReportId: true
})

export const preconsumerScrapMaterialUpdateSchema = preconsumerScrapMaterialSchema.pick({
  stockChangeType: true,
  date: true,
  details: true,
  internalId: true,
  quantityInTonnes: true,
  proofFilePath: true
})

export type PreconsumerScrapMaterial = z.infer<typeof preconsumerScrapMaterialSchema>

export type PreconsumerScrapMaterialCreatePayload = z.infer<
  typeof preconsumerScrapMaterialCreateSchema
>

export type PreconsumerScrapMaterialUpdatePayload = z.infer<
  typeof preconsumerScrapMaterialUpdateSchema
>

export type PreconsumerScrapMaterialWithEmissionReport = PreconsumerScrapMaterial & {
  emissionReport: EmissionReportWithProductionRoute
}

export const scrapMaterialName = 'Pre-consumer Scrap'
